<div class="survey-display-container" [class.hidden]="!isActive">
    <div class="ui basic segment app-grid" style="padding-top: 25px">
        <div class="columns-3">
            <!--Save button-->
            <ui-button class="margin-bottom-1" data-cy="save-button" (click)="save()" type="ghost" size="no-padding">
                <mat-icon svgIcon="chevronLeft" />
                {{ 'surveys.fillSurvey.menu.back' | translate }}
            </ui-button>
            <div class="flex">
                <app-header [title]="survey.title"></app-header>
                <app-autosave-info [lastSaved]="autosave"></app-autosave-info>
            </div>

            <p [innerHTML]="'surveys.fillSurvey.menu.fillGuideNote' | translate"></p>

            <ui-button
                class="w-100 no-margin"
                type="primary"
                size="full-width"
                (click)="submit()"
                [disabled]="!isComplete()"
            >
                {{ 'surveys.fillSurvey.menu.submitSurvey' | translate }}
            </ui-button>
        </div>

        <form class="ui form fields columns-9">
            <h2 class="ui left floated header">
                {{ survey.title || 'Untitled' }}
            </h2>

            <div class="clear"></div>

            <ng-container *ngIf="jsonResponse">
                <div
                    *ngFor="let field of fields; let index = index; trackBy: trackByFn"
                    class="field toolkit-item"
                    [attr.arr-index]="index"
                    [attr.field-index]="field.index"
                >
                    <ng-container [ngSwitch]="field.type">
                        <div *ngSwitchCase="'freeform'">
                            <div class="ui horizontal divider">
                                {{
                                    'surveys.fillSurvey.questionLabelWithIndex'
                                        | translate: { questionIndex: index + 1 }
                                }}
                                <ui-badge
                                    *ngIf="field.isOptional && performanceReviewImprovements"
                                    class="optional-badge"
                                    >{{ 'performance.show.optional' | translate }}</ui-badge
                                >
                            </div>
                            <div class="field">
                                <label class="question-label-wrap" [innerHTML]="field.question | nl2br | sanitizeHtml">
                                </label>
                                <textarea
                                    name="question-{{ field.index }}"
                                    [(ngModel)]="jsonResponse['question' + field.index]"
                                ></textarea>
                            </div>
                        </div>

                        <div *ngSwitchCase="'multiple'">
                            <div class="ui horizontal divider">
                                {{
                                    'surveys.fillSurvey.questionLabelWithIndex'
                                        | translate: { questionIndex: index + 1 }
                                }}
                                <ui-badge
                                    *ngIf="field.isOptional && performanceReviewImprovements"
                                    class="optional-badge"
                                    >{{ 'performance.show.optional' | translate }}</ui-badge
                                >
                            </div>
                            <div class="field">
                                <label class="question-label-wrap" [innerHTML]="field.question | nl2br | sanitizeHtml">
                                </label>
                            </div>
                            <div class="grouped fields">
                                <div
                                    *ngFor="let choice of field.choices; let choiceIndex = index; let first = first"
                                    class="field"
                                >
                                    <div
                                        class="ui radio checkbox"
                                        [attr.data-value]="choiceIndex"
                                        [attr.data-model]="'question' + field.index"
                                    >
                                        <input type="radio" name="question-{{ field.index }}" />
                                        <label>{{ choice }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngSwitchCase="'rating'">
                            <div class="ui horizontal divider">
                                {{
                                    'surveys.fillSurvey.questionLabelWithIndex'
                                        | translate: { questionIndex: index + 1 }
                                }}
                                <ui-badge
                                    *ngIf="field.isOptional && performanceReviewImprovements"
                                    class="optional-badge"
                                    >{{ 'performance.show.optional' | translate }}</ui-badge
                                >
                            </div>
                            <div class="field">
                                <label class="question-label-wrap" [innerHTML]="field.question | nl2br | sanitizeHtml">
                                </label>
                            </div>
                            <div
                                class="ui massive star rating"
                                [attr.data-rating]="jsonResponse['question' + field.index]"
                                data-max-rating="10"
                                [attr.data-model]="'question' + field.index"
                            ></div>
                            <div class="rating-labels">
                                <span
                                    >{{ 'surveys.fillSurvey.low' | translate }} <br />{{
                                        'surveys.fillSurvey.negative' | translate
                                    }}</span
                                >
                                <span
                                    >{{ 'surveys.fillSurvey.high' | translate }} <br />{{
                                        'surveys.fillSurvey.positive' | translate
                                    }}</span
                                >
                            </div>
                        </div>

                        <div *ngSwitchCase="'scale'">
                            <div class="ui horizontal divider">
                                {{
                                    'surveys.fillSurvey.questionLabelWithIndex'
                                        | translate: { questionIndex: index + 1 }
                                }}
                                <ui-badge
                                    *ngIf="field.isOptional && performanceReviewImprovements"
                                    class="optional-badge"
                                    >{{ 'performance.show.optional' | translate }}</ui-badge
                                >
                            </div>
                            <div class="field">
                                <label class="question-label-wrap" [innerHTML]="field.question | nl2br | sanitizeHtml">
                                </label>
                            </div>
                            <div class="agree-disagree-scale" [attr.data-model]="'question' + field.index">
                                <span data-value="0">
                                    <i class="fal fa-3x fa-frown"></i>
                                    <br />
                                    <span [innerHTML]="'surveys.showResults.stronglyDisagree' | translate"></span>
                                </span>
                                <span data-value="1">
                                    <i class="fal fa-3x fa-frown"></i>
                                    <br />
                                    <span [innerHTML]="'surveys.showResults.somewhatDisagree' | translate"></span>
                                </span>
                                <span data-value="2">
                                    <i class="fal fa-3x fa-meh"></i>
                                    <br />
                                    <span
                                        [innerHTML]="'surveys.showResults.neitherAgreeNorDisagree' | translate"
                                    ></span>
                                </span>
                                <span data-value="3">
                                    <i class="fal fa-3x fa-smile"></i>
                                    <br />
                                    <span [innerHTML]="'surveys.showResults.somewhatAgree' | translate"></span>
                                </span>
                                <span data-value="4">
                                    <i class="fal fa-3x fa-smile"></i>
                                    <br />
                                    <span [innerHTML]="'surveys.showResults.stronglyAgree' | translate"></span>
                                </span>
                            </div>
                        </div>

                        <div *ngSwitchCase="'boolean'">
                            <div class="ui horizontal divider">
                                {{
                                    'surveys.fillSurvey.questionLabelWithIndex'
                                        | translate: { questionIndex: index + 1 }
                                }}
                                <ui-badge
                                    *ngIf="field.isOptional && performanceReviewImprovements"
                                    class="optional-badge"
                                    >{{ 'performance.show.optional' | translate }}</ui-badge
                                >
                            </div>
                            <div class="field">
                                <label class="question-label-wrap" [innerHTML]="field.question | nl2br | sanitizeHtml">
                                </label>
                            </div>
                            <div class="true-false-scale" [attr.data-model]="'question' + field.index">
                                <span data-value="0">
                                    <i class="fa fa-3x fa-thumbs-down"></i>
                                    <br />
                                    <br />{{ 'no' | translate }}</span
                                >
                                <span data-value="1">
                                    <i class="fa fa-3x fa-thumbs-up"></i>
                                    <br />
                                    <br />{{ 'yes' | translate }}</span
                                >
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <div class="ui basic empty message" *ngIf="!fields.length">
                <i class="fa fa-3x fa-bars"></i>
                <br />
                <br />
                <div [innerHTML]="'surveys.fillSurvey.templateError' | translate"></div>
            </div>
        </form>
    </div>
</div>
